import { Pipe, PipeTransform } from "@angular/core";

export type StringOrNumber = string | number;
export type StringOrNumberArray =  string[] | number[];

/**
 * Transforma o dado fornecido em array.
 */
@Pipe({
    name: "wrapInArray"
})
export class WrapInArrayPipe implements PipeTransform {

    transform(value: StringOrNumber | StringOrNumberArray): StringOrNumberArray {
        let array = [];

        if ((typeof(value) !== "number") && !value) {
            return array;
        }

        if (Array.isArray(value)) {
            array = value;
        } else {
            array.push(value);
        }

        return array;
    }

}
